module.exports = __webpack_public_path__ + "img/cryptocom-dark.3d8f526c.png";